document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-prd-list-page]")) {
        import(/* webpackChunkName: "product-listing" */ "/Features/Products/Listing/js/product-listing-page.js").then(async (module) => {
            const productListingPage = new module.default();
            await productListingPage.init();
        });
    }
});